import React from 'react';
import { isEditorActive } from '@sitecore-jss/sitecore-jss-react';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import { TProductSeriesNavigationBarAnchorComponent } from './types/seriesNavigationBarAnchor.types';
import { NAVIGATION_BAR_ANCHOR_CLASS } from '../../constants/navigationBar.constants';
import UnreleasedComponent from '../@shared/unreleasedComponent';

const NavigationBarAnchorComponent = (props: TProductSeriesNavigationBarAnchorComponent) => {
  const isPlaceholderShown = isEditorActive();
  const placeholderShown = isPlaceholderShown ? `${NAVIGATION_BAR_ANCHOR_CLASS}--is-EE` : '';
  // Component is unreleased
  if (props?.fields?.isComponentUnreleased) {
    return <UnreleasedComponent />;
  }

  return (
    <div className={`${NAVIGATION_BAR_ANCHOR_CLASS} ${placeholderShown}`}>
      {isPlaceholderShown ? (
        <ExperienceEditorComponentPlaceholder
          image={props?.fields?.itemData?.thumbnail}
          componentName={props?.rendering?.componentName ?? 'NavigationBarAnchorComponent'}
        />
      ) : null}
    </div>
  );
};

export default NavigationBarAnchorComponent;
